export default "__VITE_ASSET__4f9ac68d__"